import _ from 'lodash';
import './math';
import { getWorkMinutesPerDay } from './dates';

export function getModeFromSeries(series, excludeWeekendOpts, useWorkingHoursInCycleTimeDays = false) {
  let array = [];
  const workMinutesPerDay = getWorkMinutesPerDay(excludeWeekendOpts, useWorkingHoursInCycleTimeDays);
  _.forEach(series, s => {
    array = array.concat(_.map(s.cards, c => Math.ceil(c.cycleTimeInMinutes / workMinutesPerDay)));
  });
  const mode = _.mode(array);
  return !!mode ? +mode : 0;
}

export function calculateCycleTimeDistribution(data, excludeWeekendOpts, useWorkingHoursInCycleTimeDays = false) {
  if (!data.percentiles || !data.percentiles.length) {
    return;
  }
  const fiftieth = _.find(data.percentiles, item => item.name == '50').value;
  const ninetyeigth = _.find(data.percentiles, item => item.name == '98').value;
  let ratio = ninetyeigth / fiftieth;

  let isFatTailed = false;
  if (ratio < 5.6) {
    const mode = getModeFromSeries(data.series, excludeWeekendOpts, useWorkingHoursInCycleTimeDays);
    ratio = ninetyeigth / mode;
    isFatTailed = ratio >= 16;
  } else {
    isFatTailed = true;
  }

  return isFatTailed;
}
